import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Service worker: push only (see public/sw.js). Reload once when a new worker takes control so deploys pick up new bundles.
if ('serviceWorker' in navigator) {
  let reloadingForNewWorker = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (reloadingForNewWorker) return;
    reloadingForNewWorker = true;
    window.location.reload();
  });

  window.addEventListener('load', () => {
    void navigator.serviceWorker
      .register('/sw.js')
      .then((reg) => {
        console.log('[ODC SW] Registered:', reg.scope);
        void reg.update();
        setInterval(() => void reg.update(), 60 * 60 * 1000);
      })
      .catch((err) => console.log('[ODC SW] Error:', err));
  });
}
